import { getCoachmarkJoyrideConfig } from '@xfers/design-system'
import React, { useCallback } from 'react'
import Joyride, { CallBackProps, STATUS, Props as JoyrideProps } from 'react-joyride'
import { useDispatch, useSelector } from 'react-redux'
import { endTour } from '~/store/tour/actions'
import { selectCallback, selectIsTourRunning, selectSteps } from '~/store/tour/selectors'

export default function Tour() {
  const dispatch = useDispatch()
  const callback = useSelector(selectCallback)
  const isTourRunning = useSelector(selectIsTourRunning)
  const steps = useSelector(selectSteps)

  const coachmarkConfig = (getCoachmarkJoyrideConfig as () => Partial<JoyrideProps>)()

  const handleJoyrideCallback = useCallback(
    (props: CallBackProps) => {
      const { status } = props

      if (callback) {
        callback(props)
      }

      switch (status) {
        case STATUS.FINISHED: {
          dispatch(endTour())
          break
        }
        case STATUS.SKIPPED: {
          dispatch(endTour())
          break
        }
        default:
          break
      }
    },
    [callback?.name]
  )

  if (!isTourRunning) {
    return <></>
  }

  return (
    <>
      <Joyride
        disableCloseOnEsc
        disableOverlayClose
        disableScrolling
        callback={handleJoyrideCallback}
        scrollOffset={0}
        steps={steps}
        {...coachmarkConfig}
      />
    </>
  )
}
